module.exports = __webpack_public_path__ + "static/media/Male-Icon-Unselected.facf0348.svg";